import { Injectable } from '@angular/core';

import { BaseStorage } from '../../core/abstractions/base.storage';
import { ManagingDataModel } from '../../models/managing-data.model';

@Injectable({
    providedIn: 'root'
})
export class ManagingDataStorage extends BaseStorage {
    private dataKey = 'managingData';

    constructor() {
        super('managing-data');
    }

    saveData(data: ManagingDataModel): void {
        this.save(data, this.dataKey);
    }

    getData(): ManagingDataModel {
        return this.get<ManagingDataModel>(this.dataKey);
    }

    eraseData(): void {
        this.remove(this.dataKey);
    }
}
